import { render, staticRenderFns } from "./private_lesson_card.vue?vue&type=template&id=35e70e8e&"
import script from "./private_lesson_card.vue?vue&type=script&lang=js&"
export * from "./private_lesson_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports